// Libraries
import React from 'react';

// Supermove
import {gql} from '@supermove/graphql';
import {UrlFiltersType, useResponsive} from '@supermove/hooks';
import {ProjectModel} from '@supermove/models';

// App
import {ProjectBlockKindType} from '@shared/modules/Project/enums/ProjectBlockKind';
import ProjectBlockWrapper from 'modules/Project/V2/Show/Blocks/components/ProjectBlockWrapper';
import ProjectClientsBlockContentDesktop from 'modules/Project/V2/Show/Blocks/components/ProjectClientsBlockContentDesktop';
import ProjectClientsBlockContentMobile from 'modules/Project/V2/Show/Blocks/components/ProjectClientsBlockContentMobile';

import {ProjectPageUrlFiltersType} from '../../types/ProjectPageUrlFilters';

const ProjectClientsBlock = ({
  project,
  handleSetPositionY,
  layoutKey,
  urlFilters,
  index,
  projectBlockKind,
  isWidget,
}: {
  project: ProjectModel;
  handleSetPositionY?: () => void;
  layoutKey?: string;
  urlFilters: UrlFiltersType<ProjectPageUrlFiltersType>;
  index: number;
  projectBlockKind: ProjectBlockKindType;
  isWidget?: boolean;
}) => {
  const responsive = useResponsive();

  return (
    <ProjectBlockWrapper
      index={index}
      query={ProjectClientsBlock.query}
      queryVariables={{projectUuid: project.uuid}}
      layoutKey={layoutKey}
      handleSetPositionY={handleSetPositionY}
      SkeletonComponent={ProjectClientsBlockContentDesktop.SkeletonComponent}
      projectBlockKind={projectBlockKind}
      isWidget={isWidget}
    >
      {({data}: {data: {project: ProjectModel}}) => {
        const {project} = data;
        const isSameBillingClient = project.client.id === project.billingClient.id;
        return (
          <React.Fragment>
            {responsive.desktop && !isWidget ? (
              <ProjectClientsBlockContentDesktop
                project={project}
                isSameBillingClient={isSameBillingClient}
                urlFilters={urlFilters}
              />
            ) : (
              <ProjectClientsBlockContentMobile
                project={project}
                isSameBillingClient={isSameBillingClient}
                urlFilters={urlFilters}
                isWidget={isWidget}
              />
            )}
          </React.Fragment>
        );
      }}
    </ProjectBlockWrapper>
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------

ProjectClientsBlock.fragment = gql`
  fragment ProjectClientsBlock on Project {
    id
    uuid
  }
`;

ProjectClientsBlock.query = gql`
  ${ProjectClientsBlockContentDesktop.fragment}
  ${ProjectClientsBlockContentMobile.fragment}

  query ProjectClientsBlock($projectUuid: String!) {
    ${gql.query}
    project(uuid: $projectUuid) {
      id
      ...ProjectClientsBlockContentDesktop
      ...ProjectClientsBlockContentMobile
    }
  }
`;

export default ProjectClientsBlock;
